<script setup lang="ts">
import Message from 'primevue/message';
import Button from 'primevue/button';

import { useCurrentCalculation } from '../composables/useCurrentCalculation';
import { useSaveCalculation } from '../composables/useSaveCalculation';

const { currentCalculation } = useCurrentCalculation();
const { saveCalculation, isLoading } = useSaveCalculation();

function handleSaveCalculation() {
  if (!currentCalculation.value) return;

  saveCalculation(currentCalculation.value);
}
</script>

<template>
  <Message class="bg-brand-50/25 text-brand-500 [&__.p-message-text]:w-full" severity="primary">
    <div class="flex w-full items-center justify-between gap-4">
      <p>
        Zmiany nie zostały jeszcze zapisane online. Naciśnij 'Zapisz', aby zapisać je w systemie.
      </p>

      <Button
        class="ml-auto font-semibold"
        size="small"
        :disabled="isLoading"
        @click="handleSaveCalculation"
      >
        Zapisz
      </Button>
    </div>
  </Message>
</template>
